const MSD_EMAIL_SENT_EVENT = "misdelivery:email-sent";
const MSD_EMAIL_SENT_FLAG_PREFIX = "misdelivery:email-sent:";

export const notifyMisdeliveryEmailSent = (osdNumber: string): void => {
  const normalizedOsd = (osdNumber ?? "").toString().trim();
  if (!normalizedOsd) return;

  // Persist a one-time signal so parent can refresh even after route remount.
  globalThis.sessionStorage.setItem(
    `${MSD_EMAIL_SENT_FLAG_PREFIX}${normalizedOsd}`,
    Date.now().toString(),
  );

  globalThis.dispatchEvent(
    new CustomEvent(MSD_EMAIL_SENT_EVENT, {
      detail: { osdNumber: normalizedOsd },
    }),
  );
};

export const subscribeMisdeliveryEmailSent = (
  onEmailSent: (osdNumber: string) => void,
): (() => void) => {
  const handler: EventListener = (event) => {
    const customEvent = event as CustomEvent<{ osdNumber?: string }>;
    const eventOsd = customEvent?.detail?.osdNumber?.toString().trim();
    if (!eventOsd) return;

    onEmailSent(eventOsd);
  };

  globalThis.addEventListener(MSD_EMAIL_SENT_EVENT, handler);

  return () => {
    globalThis.removeEventListener(MSD_EMAIL_SENT_EVENT, handler);
  };
};

export const consumeMisdeliveryEmailSentFlag = (osdNumber: string): boolean => {
  const normalizedOsd = (osdNumber ?? "").toString().trim();
  if (!normalizedOsd) return false;

  const key = `${MSD_EMAIL_SENT_FLAG_PREFIX}${normalizedOsd}`;
  const hasSignal = Boolean(globalThis.sessionStorage.getItem(key));
  if (hasSignal) {
    globalThis.sessionStorage.removeItem(key);
  }

  return hasSignal;
};
